import React, { useEffect, useState } from 'react';
import SpauiColumns from '@tencent/spaui-columns';
import { filter } from 'lodash';
import { RPCFactory } from '../../../utils/RequestUtil';
import { judgeIsFromTMC } from '../../../utils';

export const LeadsTagSelector = (props) => {
  const [cellsConfig, setCellsConfig] = useState({
    null: {
      name: '选取标签',
      list: [],
    },
  });
  const [cellsConfigMap, setCellsConfigMap] = useState({});
  const isEditable = window.pageProps.privileges.indexOf('TAG_MANAGE') !== -1;

  const columnCancel = () => {
    props.hideAddLabelDialog();
  };
  const columnSubmit = (state) => {
    props.hideAddLabelDialog();
    const customizedSelected = filter(state.selected, (item) => !!cellsConfigMap[item]);
    if (typeof props.updateFn === 'function') {
      const updatedTags = customizedSelected.map((tagId) => {
        const tag = cellsConfigMap[tagId];
        return {
          tagId,
          tagName: tag.cellName,
          customizedTagGroup: tag.customizedTagGroup,
        };
      });
      props.updateFn(updatedTags);
      return;
    }
    RPCFactory.leadsManage
      .addLeadsLabel(props.leadsId, customizedSelected)
      .done((data) => {
        props.setSelected(
          state.selected.map((item) => ({
            tagId: item,
            tagName: cellsConfigMap[item]
              ? cellsConfigMap[item].cellName
              : filter(props.selected, (e) => e.tagId == item)[0].tagName,
            customizedTagGroup: cellsConfigMap[item] ? cellsConfigMap[item].customizedTagGroup : false,
          })),
        );
      })
      .fail((ret, msg) => {
        window.alert(`操作失败,${msg}`);
      });
  };
  const goToLabelSetting = () => {
    if(judgeIsFromTMC()) {
      // 跳转标签管理
      top.postMessage({ type: 'goToLabelSetting', }, '*');
    } else {
      window.location.hash = '#/system/leadsManageSetting/label';
      location.reload();
    }
  };
  useEffect(() => {
    RPCFactory.labelGroupManage
      .getGroups({ withChildren: true })
      .done((data) => {
        const tagsList = data.entities.filter((tagGroup) => tagGroup.customizedTagGroup);
        const cellConfigList = tagsList.map((tagGroup) => {
          const tagList = tagGroup.tagList.map((tagItem) => ({
            name: tagItem.tagId.toString(),
            displayName: tagItem.tagName,
            cellName: tagItem.tagName,
            align: 'left',
            privilege: 'ALL',
          }));
          return {
            name: tagGroup.tagGroupName,
            columns: [...tagList],
          };
        });
        const cellsConfig = {
          null: {
            name: '选取标签',
            list: cellConfigList,
          },
        };
        setCellsConfig(cellsConfig);
        const cellsConfigMap = {};
        tagsList.forEach((tagGroup) => {
          tagGroup.tagList.forEach((tagItem) => {
            cellsConfigMap[tagItem.tagId] = {
              name: tagItem.tagId.toString(),
              displayName: tagItem.tagName,
              cellName: tagItem.tagName,
              customizedTagGroup: tagGroup.customizedTagGroup,
              align: 'left',
              privilege: 'ALL',
              width: 180,
            };
          });
        });
        setCellsConfigMap(cellsConfigMap);
      })
      .fail((ret, msg) => {});
  }, []);

  return (
    <SpauiColumns
      className="label-selector"
      show={props.show}
      hideHeader={true}
      onCancel={columnCancel}
      onSubmit={columnSubmit}
      selected={!props.selected ? [] : props.selected.map((tag) => (tag.tagId ? tag.tagId.toString() : tag.tagId))}
      cellsConfig={cellsConfig}
      cellsConfigMap={cellsConfigMap}
      storable={false}
      dialogProps={{
        hideHeader: true,
      }}
      TipComponent={
        isEditable
          ? () => (
              <a
                className="goto-label-setting"
                href="javascript:void(0)"
                onClick={() => {
                  goToLabelSetting();
                }}
              >
                标签管理
              </a>
            )
          : () => <div />
      }
    />
  );
};
